<template>
  <div>
    <FullscreenDialog :value="isVisible">
      <TaxiCourseDrawer
        v-if="isTaxiCourse"
        :course="course"
        :selectedRide.sync="selectedRideIdx"
        @openSettlementColumn="openSettlementDrawer"
        v-on="$listeners"
      ></TaxiCourseDrawer>
      <ServiceCourseDrawer
        v-else
        :course="course"
        :selectedRide.sync="selectedRideIdx"
        @openSettlementColumn="openSettlementDrawer"
        v-on="$listeners"
      />
    </FullscreenDialog>
    <FullscreenDialog content-class="taxi-ride-modal" v-if="isRideDrawerVisible" :value="isRideDrawerVisible">
      <TaxiRideDrawer
        v-if="isTaxiCourse"
        :course="course"
        :ride="selectedRide"
        @close="closeRideDrawer"
      ></TaxiRideDrawer>
      <ServiceRideDrawer v-else :course="course" :ride="selectedRide" @close="closeRideDrawer" />
    </FullscreenDialog>
    <FullscreenDialog :value="isSettlementDrawerVisible">
      <SettlementDrawerFactory
        :ride="selectedRide"
        :course="course"
        @close="closeSettlementDrawer"
      ></SettlementDrawerFactory>
    </FullscreenDialog>
  </div>
</template>

<script>
import { COURSE_TYPE_DICT } from '@/core/dict/course-dict';
import FullscreenDialog from '@/component/Dialog/fullscreen-dialog';
import TaxiCourseDrawer from './course-drawer/taxi-course-drawer';
import TaxiRideDrawer from './ride-drawer/taxi-ride-drawer';
import ServiceRideDrawer from './service/ride-drawer/service-ride-drawer';
import SettlementDrawerFactory from './settlement-drawer/settlement-drawer-factory';
import ServiceCourseDrawer from './service/service-course-drawer';

export default {
  name: 'MobileCourseDrawer',
  inheritAttrs: false,
  components: {
    FullscreenDialog,
    TaxiCourseDrawer,
    TaxiRideDrawer,
    SettlementDrawerFactory,
    ServiceCourseDrawer,
    ServiceRideDrawer,
  },
  props: {
    course: Object,
  },
  data() {
    return {
      isVisible: false,
      isRideDrawerVisible: false,
      isSettlementDrawerVisible: false,
      selectedRideIdx: null,
    };
  },
  computed: {
    selectedRide() {
      return this.course.rides[this.selectedRideIdx];
    },
    isTaxiCourse() {
      return this.course && this.course['@type'] === COURSE_TYPE_DICT.TAXI_COURSE;
    },
  },
  methods: {
    closeDrawer() {
      this.$emit('closeDrawer');
    },
    resetCourseForm() {
      this.$store.commit('courseCreation/RESET_COURSE');
    },
    closeRideDrawer() {
      this.isRideDrawerVisible = false;
      this.selectedRideIdx = null;
    },
    openSettlementDrawer() {
      this.isSettlementDrawerVisible = true;
    },
    closeSettlementDrawer() {
      this.isSettlementDrawerVisible = false;
    },
  },
  watch: {
    course: {
      handler(val) {
        this.isVisible = !!val;
      },
      immediate: true,
    },
    isVisible(val) {
      if (!val) {
        this.closeDrawer();
        this.resetCourseForm();
      }
    },
    selectedRideIdx(val) {
      this.isRideDrawerVisible = val !== null;
    },
  },
};
</script>

<style lang="scss">
.taxi-ride-modal {
  overflow-y: hidden;

  .v-card {
    height: inherit;
  }
}
</style>
